<template>
  <div>
    <!--gmx-main-navbar /-->
    <MainNavBar />
    <Hero :hero="heroLandingAconexRegister" />
    <!--Hero :hero="heroLanding" /-->
    <SectionProblemsSlowingYouDown />
    <SectionTrinpodServer />
    <SectionTrinappSuite />
    <Section :content="findActionableInfo" />
    <Section :content="ownYourInfo" />
    <Section :content="systemsApproach" />
    <Section :content="formFollowsFunction" />
    <Section :content="singleSourceOfTruth" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import GmxMainNavbar from '../components/gmx-main-navbar.vue';
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionProblemsSlowingYouDown from '@/components/section-problems-slowing-you-down.vue';
import SectionTrinpodServer from '@/components/section-trinpod-server.vue';
import SectionTrinappSuite from '@/components/section-trinapp-suite.vue';
import GmxFooter from '@/components/footer.vue';

export default {
  name: 'Main',
  components: {
    GmxMainNavbar,
    MainNavBar,
    Hero,
    Section,
    SectionProblemsSlowingYouDown,
    SectionTrinpodServer,
    SectionTrinappSuite,
    GmxFooter
  },
  data() {
    return { 
      heroLandingAconexRegister: { 
        eyebrowIcon: '',
        eyebrowTitle: '',
        eyebrowSubtitle: 'Aconex Accelerator',
        header: 'Introducing the Oracle Aconex Accelerator!',
        subheader: 'Aconex Project members can automatically register documents with multiple fields of information to Aconex up to 100+ times faster, and find actionable information in seconds using the Accelerator\'s powerful search, tag and document linking capabilities.',
        img: '',
        videoId: '945901280',
        buttons: [
          { label: 'Aconex Accelerator', path: '/Aconex', id: '' },
        ]
      },
      /*heroLanding: { 
        eyebrow: 'Property Management \u0026 AECO: Architecture, Engineering, Construction \u0026 Operations',
        header: 'These problems slowing you down?',
        subheader: '',
        videoId: '892755542',
        img: 'hero-intelligentPDF.png',
        buttons: [
          { label: 'Finding Actionable Information Takes Hours per day', path: '', id: 'find-actionable-info' },
          { label: 'Information in Multiple Incompatible App Silos', path: '', id: 'own-your-info' },
          { label: 'Information Stored Without a Systems Approach', path: '', id: 'systems-approach' },
          { label: 'BIM captures Final Form, but not Function', path: '', id: 'form-follows-function' }, 
          { label: 'Rework from Outdated Document Versions', path: '', id: 'single-source-of-truth' },
        ]
      },*/
      findActionableInfo: { 
        eyebrow: 'Problem: Finding Actionable Information Takes Hours per day',
        eyebrowIcon: '',
        headline: 'Find Actionable Information in Seconds',
        paragraphs: [
          'Use next generation search technology to find information from inside hundreds of thousands of PDF documents. Find all information related to system tags in one place. Clickable hyperlinks created in the PDFs instantly navigate between referenced documents and system objects.'
        ],
        id: 'find-actionable-info',
        image: '',
        videoId: '686725858',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: '',
        learnMoreLink: '/intelligent-pdf'
      },
      ownYourInfo: { 
				eyebrow: 'Problem: Information in Multiple Incompatible App Silos',
				eyebrowIcon: '',
        headline: 'Use Any Custom Application to Interoperate Globally and Securely with the Supply Chain',
        paragraphs: [
          'To enable efficient collaboration with design, construction, property and supply chain partners, choose from an ecosystem of modular applications, created by multiple vendors, using a common unifying global data framework for property & AEC systems. Ensure 100% control & ownership over your information, with state of the art security technology.'
        ],
				id: 'own-your-info',
				image: 'solid-interoperability.png',
				videoId: '',
				colOrderText: 1,
				colOrderImage: 2,
				bgClass: 'bg-light-grad',
				html: '',
				learnMoreLink: '/projects'
			},
      systemsApproach: { 
				eyebrow: 'Problem: Information Stored Without a Systems Approach',
				eyebrowIcon: '',
        headline: 'Instantly Find Information by System Relations',
        paragraphs: [
          'Find documents and information in the Digital Twin according to the actual building system relations. Example: find all documents and information about RestRoom Women 011 by selecting the room.'
        ],
				id: 'systems-approach',
				image: 'Digital-Twin-search.png',
				videoId: '',
				colOrderText: 2,
				colOrderImage: 1,
				bgClass: 'bg-light-grad',
				html: '',
				learnMoreLink: '/projects'
			},
      formFollowsFunction: { 
				eyebrow: 'Problem: BIM Captures Final Form, But Not Function',
				eyebrowIcon: '',
        headline: '\"Form follows Function\"',
        paragraphs: [
          '- Louis Sullivan',
          'Capture the why as well as continuous change, not just the end result form.The System\'s relations, functions, interfaces and state changing events through time are needed for dynamic system automation and optimization.'
        ],
				id: 'form-follows-function',
				image: '',
				videoId: '683264838',
				colOrderText: 1,
				colOrderImage: 2,
				bgClass: 'bg-light-grad',
				html: '',
				learnMoreLink: '/projects'
			},
      singleSourceOfTruth: { 
				eyebrow: 'Problem: Rework from Outdated Document Versions',
				eyebrowIcon: '',
        headline: 'Prevent Rework for the Whole Supply Chain with a Single Source of Truth',
        paragraphs: [
          'The entire supply chain collaborates from a single source of truth in the form of an internet URL that persists across versions, for all Documents and System Objects with full read/write event traceability, giving full accountability. Building professionals will consistently be served the latest version of the documents.'
        ],
				id: 'single-source-of-truth',
				image: 'single-source-of-truth.png',
				videoId: '',
				colOrderText: 2,
				colOrderImage: 1,
				bgClass: 'bg-light-grad',
				html: '',
				learnMoreLink: '/projects'
			},
    }
  }
};
</script>

<style>
.eyebrow-title, .eyebrow-subtitle {
  color: #555b60;
}
.eyebrow-title {
  font-weight: 700 !important;
}
.hero-btn-wrapper > .btn {
    width: 164px;
    padding: 0.5rem 1rem !important;
    margin-right: 0.5rem;
  }
.problems-btn-wrapper > .btn {
  border: 1px solid #dee2e6;
  padding: 0.5rem 0.5rem !important;
  margin-bottom: 0.5rem;
}
.hero-btn-wrapper > .btn {
  font-weight: bold;
  margin-bottom: 0.5rem;
}
</style>
